import React from "react";
import styles from "./Progress.module.css";
import { LinearProgress } from "@mui/material";

function Progress() {
  return (
    <div className={styles.progress}>
      <LinearProgress />
    </div>
  );
}

export default Progress;
